import { supabase } from './supabase';
import { createContactShareCore, createEventShareByIdCore, createEventShareFromPayloadCore, resolveShareCore } from '@gv/core';

export type ShareType = 'contact' | 'event';

export interface ShareLinkRow {
    id: string;
    token: string;
    type: ShareType;
    contact_id?: string | null;
    event_id?: string | null;
    payload?: any;
    expires_at: string;
    created_at: string;
}

export async function createContactShare(contactId: string, days: number = 7): Promise<string> {
    return await createContactShareCore(supabase as any, contactId, days);
}

export async function createEventShareById(eventId: string, days: number = 7): Promise<string> {
    return await createEventShareByIdCore(supabase as any, eventId, days);
}

export async function createEventShareFromPayload(payload: any, days: number = 7): Promise<string> {
    return await createEventShareFromPayloadCore(supabase as any, payload, days);
}

export async function resolveShare(token: string): Promise<{ type: ShareType; contact?: any; event?: any; payload?: any } | null> {
    return await resolveShareCore(supabase as any, token) as any;
}
